<section id="shipping-section-market" class="feat-pro2" >
  <div class="container flex-column flex-md-row justify-content-between px-0 d-flex">
    <div class="market-bg-color-green d-flex flex-column align-items-center position-relative px-0 py-4"
         style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center text-white font-weight-bold mt-3" >Alimentos<br>a Cuba</span>
      <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#06483D">Envía productos<br>frescos y en conserva.</span>
      <picture class="d-block d-md-none">
        <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
        <source data-srcset="assets/market/alimentos1.png" type="image/png" />
        <img width="300px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-md-block d-lg-none">
        <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
        <source data-srcset="assets/market/alimentos1.png" type="image/png" />
        <img width="220px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-lg-block d-xl-none">
        <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
        <source data-srcset="assets/market/alimentos1.png" type="image/png" />
        <img width="300px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-xl-block">
        <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
        <source data-srcset="assets/market/alimentos1.png" type="image/png" />
        <img width="365px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>

      <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;">
        <button routerLink="tienda-online-cuba/comida"
                class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                style="color: #47BFAB;">
          Comprar Ahora
        </button>
      </div>
    </div>
    <div class="market-bg-color-blue d-flex flex-column align-items-center position-relative px-0 py-4"
         style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center mt-3 text-white font-weight-bold" >Envíos Marítimos<br>
A cuba</span>
      <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#062A6F">Reciben las compras<br> a Cuba online<br>
de 4 a 7 semanas.</span>
      <picture class="d-block d-md-none">
        <source data-srcset="assets/market/ship.png" type="image/webp" />
        <source data-srcset="assets/market/ship.png" type="image/png" />
        <img width="300px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-md-block d-lg-none">
        <source data-srcset="assets/market/ship.png" type="image/webp" />
        <source data-srcset="assets/market/ship.png" type="image/png" />
        <img width="220px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-lg-block d-xl-none">
        <source data-srcset="assets/market/ship.png" type="image/webp" />
        <source data-srcset="assets/market/ship.png" type="image/png" />
        <img width="300px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-xl-block">
        <source data-srcset="assets/market/ship.png" type="image/webp" />
        <source data-srcset="assets/market/ship.png" type="image/png" />
        <img width="365px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;">
        <button routerLink="tienda-online-cuba/productos-envio-cuba"
                class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                style="color: #69f;">
          Comprar Ahora
        </button>
      </div>
    </div>
    <div class="market-bg-color-red d-flex flex-column align-items-center position-relative px-0 py-4"
         style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center text-white font-weight-bold mt-3" >Tecnología y <br>celulares</span>
      <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#960505">Los dispositivos más<br> modernos al mejor precio.</span>
      <picture class="d-block d-md-none">
        <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
        <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
        <img width="300px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-md-block d-lg-none">
        <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
        <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
        <img width="220px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-lg-block d-xl-none">
        <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
        <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
        <img width="300px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <picture class="d-none d-xl-block">
        <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
        <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
        <img style="padding-right: 20px;padding-left: 20px" width="365px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
      </picture>
      <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;">
        <button routerLink="tienda-online-cuba/celulares-computadoras"
                class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                style="color: #FB8E8E">
          Comprar Ahora
        </button>
      </div>
    </div>
  </div>
  <!--<div class="d-none container">
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-12 padding-fix-l20">
              <div class="ftr-product">
                <div class="tab-content" >
                  <div class="tab-pane fade show active" id="all" role="tabpanel">
                    <div class="tab-slider owl-carousel custom" id="shipping-slider">
                      <div class="tab-item">
                        <div class="market-bg-color-green d-flex flex-column align-items-center position-relative px-0 py-4"
                             style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center mt-3 text-white font-weight-bold" >Alimentos<br>a Cuba</span>
                          <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#06483D">Envía productos<br>frescos y en conserva.</span>
                          <picture class="d-block d-md-none">
                            <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
                            <source data-srcset="assets/market/alimentos1.png" type="image/png" />
                            <img width="300px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-md-block d-lg-none">
                            <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
                            <source data-srcset="assets/market/alimentos1.png" type="image/png" />
                            <img width="220px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-lg-block d-xl-none">
                            <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
                            <source data-srcset="assets/market/alimentos1.png" type="image/png" />
                            <img width="300px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-xl-block">
                            <source data-srcset="assets/market/alimentos1.png" type="image/webp" />
                            <source data-srcset="assets/market/alimentos1.png" type="image/png" />
                            <img width="365px" class="mr-auto lazyload" src="assets/market/alimentos1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>

                          <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;">
                            <button routerLink="tienda-online-cuba/comida"
                                    class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                                    style="color: #47BFAB;">
                              Comprar Ahora
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="tab-item">
                        <div class="market-bg-color-blue d-flex flex-column align-items-center position-relative px-0 py-4"
                             style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center mt-3 text-white font-weight-bold" >Envíos Marítimos<br>
A cuba</span>
                          <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#062A6F">Recibe las compras<br>online a domicilio<br>
en todo el país.</span>
                          <picture class="d-block d-md-none">
                            <source data-srcset="assets/market/ship.png" type="image/webp" />
                            <source data-srcset="assets/market/ship.png" type="image/png" />
                            <img width="300px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-md-block d-lg-none">
                            <source data-srcset="assets/market/ship.png" type="image/webp" />
                            <source data-srcset="assets/market/ship.png" type="image/png" />
                            <img width="220px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-lg-block d-xl-none">
                            <source data-srcset="assets/market/ship.png" type="image/webp" />
                            <source data-srcset="assets/market/ship.png" type="image/png" />
                            <img width="300px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-xl-block">
                            <source data-srcset="assets/market/ship.png" type="image/webp" />
                            <source data-srcset="assets/market/ship.png" type="image/png" />
                            <img width="365px" class="ml-auto lazyload" src="assets/market/ship.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;color: #FB8E8E">
                            <button routerLink="tienda-online-cuba/productos-envio-cuba"
                                    class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                                    style="color: #47BFAB;">
                              Comprar Ahora
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="tab-item">
                        <div class="market-bg-color-red d-flex flex-column align-items-center position-relative px-0 py-4"
                             style="border-radius: 15px;max-width: 390px; max-height: 550px">
    <span class="h2 text-center mt-3 text-white font-weight-bold" >Tecnología y <br>celulares</span>
                          <span class="text-center mt-lg-3 h2-subtitle font-weight-bold" style="color:#960505">Los dispositivos más<br>modernos al mejor precio.</span>
                          <picture class="d-block d-md-none">
                            <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
                            <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
                            <img style="padding-left: 25px;padding-right: 25px" width="200px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-md-block d-lg-none">
                            <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
                            <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
                            <img width="220px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-lg-block d-xl-none">
                            <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
                            <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
                            <img width="300px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <picture class="d-none d-xl-block">
                            <source data-srcset="assets/market/tecnologia1.png" type="image/webp" />
                            <source data-srcset="assets/market/tecnologia1.png" type="image/png" />
                            <img style="padding-left: 20px; padding-right: 20px" width="365px" class="ml-auto lazyload" src="assets/market/tecnologia1.png" alt="Envíos a Cuba - Amazon Cubano [App móvil] | Cubatel Market"/>
                          </picture>
                          <div class="position-absolute pb-2 d-flex justify-content-center cta" style="bottom: 10%;">
                            <button routerLink="tienda-online-cuba/celulares-computadoras"
                                    class="btn bg-white px-2 py-2 font-weight-bold OpenSans rounded-pill w-75 position-relative"
                                    style="color: #FB8E8E">
                              Comprar Ahora
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->

</section>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>
